import React from "react";

const BrandLogo = () => {
  return (
    <div className="flex items-center">
      <svg
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.2114 38.4227C29.8215 38.4227 38.4227 29.8215 38.4227 19.2114C38.4227 15.402 37.314 11.8517 35.4017 8.86535C35.2877 8.8761 35.169 8.88153 35.0457 8.88153H21.8239V17.9341H34.0849C35.5947 17.9341 36.464 18.753 36.464 20.2087C36.464 21.7099 35.5947 22.5742 34.0849 22.5742H21.8239V33.5829C21.8239 35.5845 20.8631 36.6762 18.9874 36.6762C17.0659 36.6762 15.9679 35.5845 15.9679 33.5829V7.33485C15.9679 5.33327 17.0659 4.24149 19.0789 4.24149H31.2532C27.9589 1.58818 23.7706 0 19.2114 0C8.60122 0 0 8.60122 0 19.2114C0 29.8215 8.60122 38.4227 19.2114 38.4227Z"
          fill="url(#paint0_linear_65_33765)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_65_33765"
            x1="14.5999"
            y1="5.71143"
            x2="24.0999"
            y2="40.7114"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2AAC95" />
            <stop offset="0.989583" stop-color="#76D1F7" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        width="64"
        height="18"
        className="ml-2"
        viewBox="0 0 64 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.3066 17.7034C3.28828 17.7034 3.7911 17.1288 3.7911 16.0753V10.2809H10.208C10.9981 10.2809 11.4531 9.82598 11.4531 9.03584C11.4531 8.26964 10.9981 7.83866 10.208 7.83866H3.7911V3.07388H10.7108C11.5249 3.07388 11.9559 2.61895 11.9559 1.82881C11.9559 1.06262 11.5249 0.631632 10.7108 0.631632H2.35448C1.30096 0.631632 0.726318 1.20628 0.726318 2.2598V16.0753C0.726318 17.1288 1.30096 17.7034 2.3066 17.7034Z"
          fill="#1E2836"
        />
        <path
          d="M15.6088 3.40909C16.7581 3.40909 17.3806 2.83444 17.3806 1.82881C17.3806 0.799238 16.7581 0.248535 15.6088 0.248535C14.4834 0.248535 13.8369 0.799238 13.8369 1.82881C13.8369 2.83444 14.4834 3.40909 15.6088 3.40909ZM15.6088 17.6795C16.5905 17.6795 17.1172 17.0809 17.1172 16.0513V7.26401C17.1172 6.21049 16.5665 5.63585 15.6088 5.63585C14.651 5.63585 14.1243 6.21049 14.1243 7.26401V16.0513C14.1243 17.0809 14.651 17.6795 15.6088 17.6795Z"
          fill="#1E2836"
        />
        <path
          d="M20.9933 17.7034C21.975 17.7034 22.5017 17.1527 22.5017 16.171V10.9274C22.5017 9.10767 23.6271 7.91049 25.3749 7.91049C26.8116 7.91049 27.482 8.70063 27.482 10.5203V16.171C27.482 17.1527 28.0327 17.7034 28.9904 17.7034C29.9482 17.7034 30.4749 17.1527 30.4749 16.171V10.3767C30.4749 7.12035 29.1341 5.56401 26.3327 5.56401C24.6566 5.56401 23.22 6.28232 22.4299 7.62316V7.12035C22.4299 6.13866 21.9031 5.6119 20.9693 5.6119C20.0355 5.6119 19.5088 6.13866 19.5088 7.12035V16.171C19.5088 17.1527 20.0355 17.7034 20.9933 17.7034Z"
          fill="#1E2836"
        />
        <path
          d="M36.7951 17.7513C37.1303 17.7513 37.4895 17.7274 37.8247 17.6795C38.5669 17.5837 38.8543 17.1527 38.8543 16.3386C38.8543 15.4288 38.7345 15.1893 38.2796 15.2372C38.0641 15.2612 37.8486 15.2851 37.5853 15.2851C36.436 15.2851 35.7895 14.5908 35.7895 13.1302V1.94853C35.7895 0.966843 35.2388 0.440083 34.281 0.440083C33.3233 0.440083 32.7965 0.966843 32.7965 1.94853V13.2739C32.7965 16.2189 34.1374 17.7513 36.7951 17.7513Z"
          fill="#1E2836"
        />
        <path
          d="M43.5792 17.7513C45.2313 17.7513 46.4524 16.9612 46.9792 15.6443V16.171C46.9792 17.1527 47.482 17.7034 48.3919 17.7034C49.2778 17.7034 49.7806 17.1527 49.7806 16.171V10.4246C49.7806 7.09641 48.1524 5.56401 44.7285 5.56401C43.6031 5.56401 42.2144 5.80345 40.7539 6.40204C39.2693 7.00063 39.9158 9.27527 41.4482 8.55696C42.6215 8.00626 43.6989 7.81471 44.6327 7.81471C46.2848 7.81471 46.9313 8.46119 46.9313 10.0654V10.5682H46.0933C41.0172 10.5682 39.1975 11.4781 39.1975 14.0401C39.1975 16.1471 41.0412 17.7513 43.5792 17.7513ZM44.2017 15.6922C42.8848 15.6922 42.1186 14.9499 42.1186 13.8964C42.1186 12.6753 43.1243 12.2922 46.1172 12.2922H46.9313V12.8189C46.9313 14.495 45.7581 15.6922 44.2017 15.6922Z"
          fill="#1E2836"
        />
        <path
          d="M58.8522 17.7513C61.917 17.7513 64.0001 15.4048 64.0001 11.6457C64.0001 7.88654 61.9409 5.56401 58.8522 5.56401C57.2001 5.56401 55.7874 6.33021 55.0931 7.52739V1.94853C55.0931 0.966843 54.5424 0.440083 53.5846 0.440083C52.6269 0.440083 52.1001 0.966843 52.1001 1.94853V16.171C52.1001 17.1527 52.6269 17.7034 53.5846 17.7034C54.5184 17.7034 55.0452 17.1527 55.0452 16.171V15.6682C55.7156 16.9612 57.1522 17.7513 58.8522 17.7513ZM58.0142 15.4767C56.2184 15.4767 55.0452 14.1837 55.0452 11.6457C55.0452 9.10767 56.2184 7.83866 58.0142 7.83866C59.786 7.83866 60.9832 9.10767 60.9832 11.6457C60.9832 14.1837 59.786 15.4767 58.0142 15.4767Z"
          fill="#1E2836"
        />
      </svg>
    </div>
  );
};

export default BrandLogo;
